export function concat (items: (string | null)[], sep?: string): string
export function concat (...args: string[]): string
export function concat (itemsOrFirst: (string | null)[] | string, ...rest: string[]): string {
  if (Array.isArray(itemsOrFirst)) {
    return itemsOrFirst.filter(Boolean).join(rest[0] ?? ' ')
  }
  return [itemsOrFirst, ...rest].join(' ')
}
